"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _interactions from "./interactions";
import * as _utils from "./utils";
import _styles from "./AlbertaBlog.module.css";

const _interactionsData = JSON.parse(
  '{"events":{"e-458":{"id":"e-458","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-459"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"bf37110d-280b-644b-4617-9f89747098d9","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"bf37110d-280b-644b-4617-9f89747098d9","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":100,"direction":"BOTTOM","effectIn":true},"createdOn":1716320005921},"e-460":{"id":"e-460","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-461"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"bf37110d-280b-644b-4617-9f89747098db","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"bf37110d-280b-644b-4617-9f89747098db","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":200,"direction":"BOTTOM","effectIn":true},"createdOn":1716320071363}},"actionLists":{"slideInBottom":{"id":"slideInBottom","useFirstGroupAsInitialState":true,"actionItemGroups":[{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":0}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":100,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":0,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}},{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":1}}]}]}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function AlbertaBlog({ as: _Component = _Builtin.Section }) {
  _interactions.useInteractions(_interactionsData, _styles);

  return (
    <_Component
      className={_utils.cx(_styles, "alberta_section-blog")}
      grid={{
        type: "section",
      }}
      tag="section"
    >
      <_Builtin.Block
        className={_utils.cx(_styles, "container-large")}
        tag="div"
      >
        <_Builtin.Block
          className={_utils.cx(_styles, "padding-section-medium")}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "padding-global")}
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(
                _styles,
                "alberta_blog-container",
                "max-width-xxlarge",
                "align-center"
              )}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(
                  _styles,
                  "alberta_blog-copy-wrap",
                  "text-align-center"
                )}
                tag="div"
              >
                <_Builtin.Paragraph
                  className={_utils.cx(
                    _styles,
                    "subheading-style",
                    "text-color-brand"
                  )}
                  data-w-id="bf37110d-280b-644b-4617-9f89747098d9"
                >
                  {"what's new"}
                </_Builtin.Paragraph>
                <_Builtin.Heading
                  className={_utils.cx(_styles, "alberta_blog-heading")}
                  data-w-id="bf37110d-280b-644b-4617-9f89747098db"
                  tag="h3"
                >
                  {"The latest Alberta rental news"}
                </_Builtin.Heading>
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(_styles, "alberta_blog-grid")}
                tag="div"
              >
                <_Builtin.Link
                  className={_utils.cx(
                    _styles,
                    "alberta_blog-card",
                    "w-node-bf37110d-280b-644b-4617-9f8974709900-747098d3"
                  )}
                  id={_utils.cx(
                    _styles,
                    "abgrowthfree_page_click_read_abrentinc"
                  )}
                  button={false}
                  block="inline"
                  options={{
                    href: "https://liv.rent/blog/rental-laws/what-is-the-alberta-rent-increase-limit",
                  }}
                >
                  <_Builtin.Paragraph
                    className={_utils.cx(_styles, "subheading-style")}
                  >
                    {"rental laws"}
                  </_Builtin.Paragraph>
                  <_Builtin.Paragraph
                    className={_utils.cx(_styles, "alberta_blog-post-heading")}
                  >
                    {"What is the Alberta rent increase limit?"}
                  </_Builtin.Paragraph>
                  <_Builtin.Block
                    className={_utils.cx(_styles, "text-link-icon")}
                    tag="div"
                  >
                    <_Builtin.Paragraph
                      className={_utils.cx(_styles, "text-style-link")}
                    >
                      {"Read more"}
                      <br />
                    </_Builtin.Paragraph>
                    <_Builtin.Image
                      loading="lazy"
                      width="auto"
                      height="auto"
                      alt=""
                      src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/6645070bb6594eeada555dc0_arrow-right.svg"
                    />
                  </_Builtin.Block>
                </_Builtin.Link>
                <_Builtin.Link
                  className={_utils.cx(_styles, "alberta_blog-card")}
                  button={false}
                  id="abgrowthfree_page_click_read_faq"
                  block="inline"
                  options={{
                    href: "https://liv.rent/blog/rental-laws/faq-landlord-tenant-responsibilities-in-alberta/",
                    target: "_blank",
                  }}
                >
                  <_Builtin.Paragraph
                    className={_utils.cx(_styles, "subheading-style")}
                  >
                    {"rental laws"}
                  </_Builtin.Paragraph>
                  <_Builtin.Paragraph
                    className={_utils.cx(_styles, "alberta_blog-post-heading")}
                  >
                    {"FAQ: Landlord &tenant responsibilities in Alberta"}
                  </_Builtin.Paragraph>
                  <_Builtin.Block
                    className={_utils.cx(_styles, "text-link-icon")}
                    tag="div"
                  >
                    <_Builtin.Paragraph
                      className={_utils.cx(_styles, "text-style-link")}
                    >
                      {"Read more"}
                      <br />
                    </_Builtin.Paragraph>
                    <_Builtin.Image
                      loading="lazy"
                      width="auto"
                      height="auto"
                      alt=""
                      src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/6645070bb6594eeada555dc0_arrow-right.svg"
                    />
                  </_Builtin.Block>
                </_Builtin.Link>
                <_Builtin.Link
                  className={_utils.cx(_styles, "alberta_blog-card")}
                  button={false}
                  id="abgrowthfree_page_click_read_rta"
                  block="inline"
                  options={{
                    href: "https://liv.rent/blog/rental-laws/understanding-the-alberta-residential-tenancy-agreement/",
                    target: "_blank",
                  }}
                >
                  <_Builtin.Paragraph
                    className={_utils.cx(_styles, "subheading-style")}
                  >
                    {"rental laws"}
                  </_Builtin.Paragraph>
                  <_Builtin.Paragraph
                    className={_utils.cx(_styles, "alberta_blog-post-heading")}
                  >
                    {"Understanding the Alberta residential tenancy agreement"}
                  </_Builtin.Paragraph>
                  <_Builtin.Block
                    className={_utils.cx(_styles, "text-link-icon")}
                    tag="div"
                  >
                    <_Builtin.Paragraph
                      className={_utils.cx(_styles, "text-style-link")}
                    >
                      {"Read more"}
                      <br />
                    </_Builtin.Paragraph>
                    <_Builtin.Image
                      loading="lazy"
                      width="auto"
                      height="auto"
                      alt=""
                      src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/6645070bb6594eeada555dc0_arrow-right.svg"
                    />
                  </_Builtin.Block>
                </_Builtin.Link>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Block>
    </_Component>
  );
}
